import React from "react";
import englishStructure from "../../assets/images/Home/Eng Gray.png";
import marathiStructure from "../../assets/images/Home/Marathi Gray.png";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

const Adminstructure = () => {
  const selectedLang = useSelector((state) => state.language.selectedLang);

  const content = {
    English: {
      title: "Administrative Set-Up/ Administration",
      breadcrumb: {
        home: "HOME",
        page: "Administrative Set-Up/ Administration",
      },
      paragraph: `The office of the Director, Archaeology and Museums, Government of Maharashtra is generally referred to as the Directorate of Archaeology, Government of Maharashtra. It is one of the 7 Directorates functioning under the Department of Tourism and Cultural Affairs Department, Ministry, Government of Maharashtra. `,

      paragraph2: `The Directorate of Archaeology and Museums, controls all the archaeology related activities under the purview and jurisdiction of the Government of Maharashtra. Archaeological excavations, explorations,  Conservation, Preservation and Research projects are carried out through the Directorate. The Regional Offices established at Aurangabad, Nagpur, Nasik, Nanded, Pune and Ratnagiri work under the supervision and control of the Directorate. There are; also, 13 museums which function under the Directorate.`,

      // paragraph3: `The Directorate of Archaeology and Museums, controls all the activities
      //      of the Maharashtra State Archaeology Department. Archaeological excavations, Conservation
      //       and research projects are carried out through the Directorate. The Regional Offices
      //       established at Chhatrapati Sambhajinagar, Nagpur, Nasik, Nanded, Pune and Ratnagiri
      //        work under the supervision and control of the Directorate.`,
    },

    मराठी: {
      title: "प्रशासकीय रचना / प्रशासन",
      breadcrumb: {
        home: "मुख्यपृष्ठ ",
        page: "प्रशासकीय रचना / प्रशासन",
      },
      paragraph: `संचालक, पुरातत्व आणि वस्तुसंग्रहालय, महाराष्ट्र शासन यांचे कार्यालय सामान्यत: पुरातत्त्व व वस्तुसंग्रहालये संचालनालय, महारष्ट्र राज्यम्हणून ओळखले जाते. सदर कार्यालय हे पर्यटन आणि सांस्कृतिक कार्य विभाग, महाराष्ट्र शासन मंत्रालय या विभागाच्या अंतर्गत येणाऱ्या ७ संचालनालयांपैकी एक आहे. `,

      paragraph2: `पुरातत्त्व व वस्तुसंग्रहालये संचालनालय, महारष्ट्र राज्य हे महाराष्ट्र शासनाच्या अधिपत्याखाली असणाऱ्या पुरातत्त्वविषयक कामांवर नियंत्रण ठेवते. उत्खनन, अन्वेषण, जतन व संवर्धन, संशोधन प्रकल्प इत्यादी कार्ये संचालनालयामार्फत केली जातात. औरंगाबाद, नागपूर, नाशिक, नांदेड, पुणे आणि रत्नागिरी येथे स्थापन झालेली प्रादेशिक कार्यालये संचालनालयाच्या देखरेखीखाली आणि नियंत्रणाखाली काम करतात.  संचालनालया अंतर्गत 13 वस्तुसंग्रहालयेही कार्यरत आहेत.  `,

      // paragraph3: `पुरातत्त्व संचालनालयाच्या अखत्यारीत प्रादेशिक कार्यालयांची स्थापना राज्यभर करण्यात आलेली असून, ही कार्यालये उत्खनन, संशोधन आणि संवर्धनासंबंधित प्रकल्पांची अंमलबजावणी करतात. या सर्व कार्यावर संचालनालयाचे नियंत्रण असते.`,
    },
  };

  const t = content[selectedLang];

  return (
    <div className="bg-[#F6F6EC] min-h-screen px-4 py-16">
      {/* Page Title and Breadcrumb */}
      <div className="text-center mb-8">
        <h1 className="text-[26px] sm:text-4xl md:text-5xl lg:text-[45px] text-black">
          {t.title}
        </h1>
        <p className="font-futura tracking-wider uppercase text-sm sm:text-base lg:text-[15px] font-medium mt-2">
          <span style={{ color: "#DD9827" }}>
            <Link to="/" className="hover:underline">
              {t.breadcrumb.home}
            </Link>{" "}
            /{" "}
          </span>
          {t.breadcrumb.page}
        </p>
      </div>

      {/* Paragraph Content */}
      <div className="max-w-7xl mx-auto px-2 sm:px-6 md:px-12 lg:px-20 text-justify text-black space-y-4 mt-12 font-futura">
        <p className="text-[14px] sm:text-lg md:text-xl lg:text-[17px] leading-[1.25rem] md:leading-[1.5rem] lg:leading-[1.5rem]">
          {t.paragraph}
        </p>

        <p className="text-[14px] sm:text-lg md:text-xl lg:text-[17px] leading-[1.25rem] md:leading-[1.5rem] lg:leading-[1.5rem]">
          {t.paragraph2}
        </p>

        {/* <p className="text-[14px] sm:text-lg md:text-xl lg:text-[17px] leading-[1.25rem] md:leading-[1.5rem] lg:leading-[1.5rem]">
          {t.paragraph3}
        </p> */}
      </div>

      {/* Image Section */}
      <div className="mt-10 sm:px-8 lg:px-10 pt-10">
        <img
          src={selectedLang === "English" ? englishStructure : marathiStructure}
          alt="Administrative Structure"
          className="w-full max-w-7xl mx-auto h-auto object-contain"
        />
      </div>
    </div>
  );
};

export default Adminstructure;
